import "./list.css";
import Header from "../../Components/Header/Header";
import SearchItem from "../../Components/Search_Item/SearchItem";
import FooterDash from "../../Components/Footer_Dash/Footer_Dash";

const List = () => {
  return (
    <div>
      <Header />
      <div className="listContainer">
        <div className="listWrapper">
          <div className="listResult">
            <SearchItem />
          </div>
        </div>
      </div>
      <FooterDash />
    </div>
  );
};

export default List;
